import { api_url } from "../../../utils";

const Zat = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=zat_239&schema_city=",
    zindex: 2,
    type: "single",
    popup: {
        default: {
            content: {
                es: {
                    id_zat: "Número de la zona de tráfico (Z239): ",
                },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.Zat",
    style: {
        regular: false,
        fillColor: "rgba(255, 255, 255, 0)",
        strokeColor: "rgb(106, 137, 132)",
        strokeWidth: 1.4,
        strokeLineDash: [2, 4],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.Zat.title",
            subtitle: "",
            attribute: "",
            symbol: "rectangle",
            legendCustomCssClass:
                "map-legend-symbol-border-2-5-px-green-106-137-132",
            class: [
                {
                    fillColor: "rgba(0, 0, 0, 0)",
                    strokeColor: "rgb(106, 137, 132)",
                    strokeWidth: 2,
                    label: "Mobility Indicators Content.layersLegend.Zat.classes.1",
                },
            ],
        },
    },
};

export default Zat;
